import axiosServices from "../utils/axios";

import type { clientDetails } from "../utils/types/type-helper";
import type { Job } from "@/utils/types/voyages";


interface apiResponse {
    data:clientDetails;
}
export interface JobResponse {
    data: clientDetails;
  }

export const fetchClientDetails =async(id:string)=>{
    const response = await axiosServices.get<apiResponse>(`/jobs/${id}`)
    return response.data.data;
}

interface updateApiResponse {
    vessel_id: String;
    voyage:String;
    notification:any[],
    assigned_phone_id:string;
    assigned_agent_id:string;
    arriving_from:string;
    phone_used_id:string;
    billing_id:string;
    appointment_number:string;
    
}
  
export const updateClientForm = async ( id: string, data: updateApiResponse ) => {
    const response = await axiosServices.put<clientDetails>(`/jobs/${id}`,data,{
        params: {
            jobId: id,
        },
        }
    );
    ;
    return response.data;
};

export const addNewClient=async()=>{
    const response = await axiosServices.post(`/jobs/`,{status_id: '616735a5-7feb-437c-97bb-08e46ef6bb30'})
    return response?.data
};

export const fetchRecentVoyages=async(vesselId:string)=>{
    const response = await axiosServices.get<{data:Job[]}>(`/jobs`,{
        params: {
            limit: 2,
            sortBy: 'created_dt',
            order: 'desc',
            vessel_id: vesselId,
            version:"historical",
            format:"berthdata",
            page:1
        }
    })
    return response.data.data;
}